import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { T2ThemeService } from 'app/trip2-theme/t2-theme.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-dashboard-providers-external',
  templateUrl: './dashboard-providers-external.component.html'
})
export class DashboardProvidersExternalComponent implements OnInit {
  public url: any;
  constructor(
    public sanitizer: DomSanitizer,
    private t2templateService: T2ThemeService
  ) {}

  ngOnInit() {
    this.getTokeToProvider();
  }

  private getTokeToProvider() {
    this.t2templateService.getProviderToken().subscribe((resp) => {
      if (resp !== undefined && resp !== null) {
        const urlRedirect = `${environment.url_webapp}/${resp.value}/pages_prov-dashboard`;
        this.url = this.sanitizer.bypassSecurityTrustResourceUrl(urlRedirect);
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/dashboard-providers-external/dashboard-providers-external.component.ts